import { SENDING_REQUEST, LOGOUT, REQUEST_ERROR, CLEAR_ERROR, REFRESH_REQUEST, PING_REQUEST, SET_CSRFTOKEN, GET_CSRFTOKEN, TIMEOUT_MODAL_STATUS, SESSION_EXPIRATION } from './constants';
export * from './constants';
export const sendingRequest = sending => ({
  type: SENDING_REQUEST,
  sending
});
export const requestError = error => ({
  type: REQUEST_ERROR,
  error
});
export const logout = () => ({
  type: LOGOUT
});
export const clearError = () => ({
  type: CLEAR_ERROR
});
export const refreshRequest = () => ({
  type: REFRESH_REQUEST
});
export const pingRequest = () => ({
  type: PING_REQUEST
});
export const setCsrfToken = payload => ({
  type: SET_CSRFTOKEN,
  payload
});
export const getCsrfToken = payload => ({
  type: GET_CSRFTOKEN,
  payload
});
export const toggleTimeoutModal = bool => ({
  type: TIMEOUT_MODAL_STATUS,
  payload: bool
});
export const updateExpiration = payload => ({
  type: SESSION_EXPIRATION,
  payload
});